import React, { useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import { HeadCell } from '../../components/tables/BakeasyTable';
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  downloadOrderDetails,
  fetchOrderHistoryById,
  OrderHistoryState,
} from '../../redux_store/slices/OrderHistorySlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import BakeasyLargeHeadingValue, {
  BakeasyLargeHeadingStatus,
} from '../../components/labels/BakeasyLargeHeadingValue';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import BakeasyLinkButton from '../../components/buttons/BakeasyLinkButton';
import { BakeasyNotesLabelText } from '../../components/labels/BakeasyLabelText';
import { BakeasyAutoCompleteTax } from '../../components/dropdowns/BakeasyAutoCompleteTax';
import { taxesState } from '../../redux_store/slices/taxesSlice';
import { BakeasyChip } from '../../components/common/BakeasyChip';
import i18n from '../../languages/languages';
import * as Button from '../../components/buttons/BakeasyButtons';

export const OrderHistoryDetails = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [supplierName, setSupplierName] = useState<any>();
  const [customeremailId, setCustomerEmailId] = useState<string>();
  const [customerMobileNo, setCustomerMobileNo] = useState<any>();

  const [ordersList, setOrdersList] = useState<any[]>([]);
  const [requestedDate, setRequestedDate] = useState<any>('');
  const [poNumber, setPoNumber] = useState<any>();
  const [storeNote, setStoreNote] = useState<any>();
  const [orderBy, setOrderBy] = useState<any>();
  const [orderId, setOrderId] = useState<any>();
  const [status, setStatus] = useState<any>();
  const [latestSupplierNote, setLatestSupplierNote] = useState<any>(undefined);
  const [latestStoreNote, setLatestStoreNote] = useState<any>(undefined);
  const [requestedDeliveryDate, setRequestedDeliveryDate] =
    useState<Dayjs | null>(null);
  const [selectedPriority, setSelectedPriority] = useState<any>('');
  const [note, setNote] = useState('');
  const [selectedShipTo, setSelectedShipTo] = useState<any>('');
  const [shipToName, setShipToName] = useState<any>('');
  const [shipToCompanyName, setShipToCompanyName] = useState<any>('');
  const [shipToAddress, setShipToAddress] = useState<any>('');
  const [shipToCity, setShipToCity] = useState<any>('');
  const [shipToPostCode, setShipToPostCode] = useState<any>('');
  const [shipToCountry, setShipToCountry] = useState<any>('');
  const [shipToState, setShipToState] = useState<any>('');

  const [preferredShippingMethod, setPreferredShippingMethod] =
    useState<any>('');
  const [selectedPreferredShippingMethod, setSelectedPreferredShippingMethod] =
    useState<any>('');

  const [selectedShippingCharge, setSelectedShippingCharge] = useState<any>('');
  const [selectedShippingCalculation, setSelectedShippingCalculation] =
    useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');

  const [selectedTaxRate1, setSelectedTaxRate1] = useState<any>(null);
  const [selectedTaxRate2, setSelectedTaxRate2] = useState<any>(null);

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>('');
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState<any>('');
  const [supplierNotes, setSupplierNotes] = useState([]);
  const [total, setTotal] = useState<any>([{}]);
  const [splitOrders, setSplitOrders] = useState<any>([]);

  let { error, value, rowsPerPage, pageNo, selectedValue } =
    useAppSelector(OrderHistoryState);
  let _taxesState = useAppSelector(taxesState);

  useEffect(() => {
    setIsEdit(location?.state?.isEdit);
    fetchData(location?.state?._id);
    setOrderId(location?.state?.orderId);
  }, []);

  const fetchData = async (_id: any) => {
    try {
      dispatch(fetchOrderHistoryById({ id: _id }));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  };

  useEffect(() => {
    if (selectedValue) {
      setData(selectedValue);
    }
  }, [selectedValue]);

  function setData(data: any) {
    setSupplierName(data?.supplierName);
    //setCustomerName(data?.name);
    setCustomerEmailId(data?.email);
    setCustomerMobileNo(data?.phone);
    setRequestedDate(data?.requestedDeliveryDate);
    setStatus(data?.status);
    setPoNumber(data?.poNumber);
    setStoreNote(data?.note);
    setOrderBy(data?.orderBy ?? '');
    setRequestedDeliveryDate(data?.requestedDeliveryDate);
    setNote(data?.note);
    setSelectedPriority(data?.selectedPriority ? 'Yes' : 'No');
    //   setOrdersList([{ _id: data.orders?._id,
    //     productName: data.orders?.productName ,
    //     unit: data.orders?.unit,
    //     price: data.orders?.price,
    //     totalprice:data.orders?.totalprice, }])
    setSelectedShipTo(data?.shipTo);
    setShipToName(data?.shipToInfo?.name);
    setShipToCompanyName(data?.shipToInfo?.companyName);
    setShipToAddress(data?.shipToInfo?.companyAddress);
    setShipToCity(data?.shipToInfo?.city);
    setShipToState(data?.shipToInfo?.state);
    setShipToPostCode(data?.shipToInfo?.zipCode);
    setShipToCountry(data?.shipToInfo?.country);
    setSelectedShippingCharge(
      data?.shippingCharges
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );
    setSelectedShippingCalculation(data?.shippingRateType);
    setShippingCharges(data?.shippingRate);

    setSelectedPaymentMethod(
      typeof data?.payment?.method === 'object'
        ? (i18n.language === 'fr' ? data?.payment?.method?.fr : data?.payment?.method?.en)
        : data?.payment?.method
    );

    setSelectedPaymentTerm(
      typeof data?.payment?.terms === 'object'
        ? (i18n.language === 'fr' ? data?.payment?.terms?.fr : data?.payment?.terms?.en)
        : data?.payment?.terms
    );

    setSelectedTaxRate1({ taxName: data?.taxes?.rate1 });
    setSelectedTaxRate2({ taxName: data?.taxes?.rate2 });

    // setSelectedPreferredShippingMethod(data?.preferredShippingMethod);
    // setPreferredShippingMethod(data?.preferredShippingMethod);
    // if (data?.preferredShippingMethod) {
    //   let includes: boolean = PREFERRED_SHIPPING_METHOD_ARRAY?.includes({
    //     id: data?.preferredShippingMethod,
    //     value: data?.preferredShippingMethod
    //   });

    //   if (includes) {
    //     setSelectedPreferredShippingMethod(data?.preferredShippingMethod);
    //   } else {
    //     setSelectedPreferredShippingMethod('Other');
    //   }

    //   setPreferredShippingMethod(data?.preferredShippingMethod);
    // }
    setPreferredShippingMethod(data?.preferredShippingMethod);

    const orders = data?.products.map((item: any) => {
      return {
        ...item,
        unitPrice: item?.price,
        totalprice: parseFloat(
          (parseFloat(item?.quantity) * parseFloat(item?.price)).toFixed(2)
        ),
        confirmedQuantity: item?.confirmedQuantity || item?.quantity,
      };
    });

    setTotal({
      ...data?.amount,
      // calculatedshippingCharge:
      //   selectedValue !== null && 'shippingRateType' in selectedValue
      //     ? selectedValue['shippingRateType'] === 'Amount'
      //       ? t('TO_BE_CONFIRMED')
      //       : data?.amount?.calculatedshippingCharge
      //     : '',
    });

    const ordersS: any = [];
    data?.subOrders?.forEach((order: any) => {
      ordersS.push({
        orderId: order.orderId,
        status: order.status,
        products: order.products?.map((item: any) => {
          return {
            ...item,
            unitPrice: item?.price,
            totalprice: (Number(item?.quantity) * Number(item?.price)).toFixed(
              2
            ),
          };
        }),
        amount: order.amount,
      });
    });

    setLatestStoreNote(
      data?.storeNotes
        ? data?.storeNotes?.at(data?.storeNotes?.length - 1)?.notes?.toString()
        : t('NO_STORE_NOTES_AVAILABLE')
    );
    setLatestSupplierNote(
      data?.supplierNotes
        ?.at(data?.supplierNotes?.length - 1)
        ?.notes?.toString()
    );

    setSplitOrders([...ordersS]);
    setOrdersList([...orders]);
  }

  const tableHeaders: HeadCell[] = [
    { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
    { id: 'userProductId', label: 'PRODUCT_ID', width: '160px' },
    {
      id: 'quantity',
      label: 'QUANTITY',
      numeric: true,
      width: '120px',
      disabled: true,
    },
    { id: 'unitPrice', label: 'UNIT_PRICE', numeric: true, width: '120px' },
    {
      id: 'confirmedQuantity',
      label: 'CONFIRMED_QUANTITY',
      numeric: true,
      width: '120px',
      disabled: true,
    },
    { id: 'totalPrice', label: 'TOTAL_PRICE', numeric: true, width: '120px' },
  ];

  function openSupplierNotesDialog(from: string) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'supplierNotesHistory',
        params: { from },
        onBack: async () => {},
      },
    });
  }

  function openStoreNotesDialog(from: string, fetchMethod: any) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'storeNotesHistory',
        params: { from, fetchMethod },
        onBack: async () => {},
      },
    });
  }

  function orderHistoryDetailsUI() {
    return (
      <Grid>
        <Grid item>
          <>
            <BakeasyAppBar
              title={t('ORDER_DETAILS')}
              onBackClick={() => {
                navigate(-1);
              }}
              menus={
                <Button.Print
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      downloadOrderDetails({
                        id: location?.state?._id,
                        downloadType: 'pdf',
                      })
                    );
                  }}
                />
              }
            />
          </>
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingValue
                heading={t('ORDER_ID')}
                value={orderId}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingStatus
                heading={t('ORDER_STATUS')}
                value={<BakeasyChip label={status} />}
              />
            </Grid>
          </Grid>
          {/* <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <BakeasyHeaderLabel message={t("CUSTOMER")} icon={PortraitIcon} />

              <BakeasyLargeHeadingValue
                heading={t("NAME")}
                value={customerName}
              />

              <BakeasyLargeHeadingValue
                heading={t("EMAIL_ID")}
                value={customeremailId}
              />

              <BakeasyLargeHeadingValue
                heading={t("MOBILE")}
                value={customerMobileNo}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <BakeasyHeaderLabel
                message={t("ORDER_INFO")}
                icon={AddShoppingCartIcon}
              />
              <BakeasyLargeHeadingValue heading={t("STATUS")} value={status} />
              <BakeasyLargeHeadingValue
                heading={t("REQUESTED_DATE")}
                value={requestedDate}
              />
              <BakeasyLargeHeadingValue
                heading={t("STORE_PO_NUMBER")}
                value={poNumber}
              />
              <BakeasyLargeHeadingValue
                heading={t("ORDER_BY")}
                value={orderBy}
              />
              <BakeasyLargeHeadingValue
                heading={t("STORE_NOTE")}
                value={storeNote}
              />
            </Grid>
          </Grid> */}
          <Grid container mt={1}>
            <BakeasyHeaderLabel message="ORDER_DETAILS" />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                label={t('SUPPLIER_NAME')}
                value={supplierName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                required={true}
                label={t('ORDER_BY')}
                disabled={true}
                type="text"
                name=""
                value={orderBy}
                maxLength={10}
                onChange={function (event: any): void {
                  setOrderBy(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                required={true}
                label={t('STORE_PO_NUMBER')}
                disabled={true}
                type="text"
                value={poNumber}
                maxLength={10}
                onChange={(event: any) => {
                  setPoNumber(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyDatePicker
                label={t('REQUESTED_DELIVERY_DATE')}
                disabled={true}
                value={dayjs(requestedDeliveryDate)}
                minDate={dayjs(new Date())}
                //   value={
                //     requestedDeliveryDate
                //       ? requestedDeliveryDate
                //       : dayjs(new Date())
                //   }
                //   minDate={dayjs(new Date()).add(1, "days")}
                //minDate={dayjs(new Date().)}
                //   onChange={(e) => setRequestedDeliveryDate(dayjs(new Date(e)))}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              {/* <Dropdown.YesNo
                label={'HIGH_PRIORITY'}
                disabled={true}
                value={selectedPriority}
                onChange={(event: any) => {
                  setSelectedPriority(event?.target?.value);
                }}
              /> */}
              <BakeasyTextField
                required={true}
                label={t('HIGH_PRIORITY')}
                disabled={true}
                type="text"
                onChange={(event: any) => {
                  setSelectedPriority(event?.target?.value);
                }}
                value={
                  selectedPriority
                    ? t(
                        `${selectedPriority?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedPriority
                }
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                disabled={true}
                label={t('NOTE')}
                placeHolder={t('ENTER_NOTE')}
                type="text"
                name="description"
                value={note}
                multiline
                rows={2}
                onChange={(event: any) => {
                  setNote(event.target.value);
                }}
                required={true}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              xl={3}
              sx={{ marginTop: 1 }}
            >
              <BakeasyNotesLabelText
                label={t('SUPPLIER_NOTES')}
                value={latestSupplierNote}
                maxLength={800}
              />
              <BakeasyLinkButton
                style={{ fontSize: '0.9rem' }}
                label={t('VIEW_ALL')}
                onClick={() => {
                  if (latestSupplierNote === undefined) {
                    dispatch(
                      showErrorSnackbar({
                        message: t('NO_SUPPLIER_NOTE_AVAILABLE'),
                      })
                    );
                    return;
                  }
                  openSupplierNotesDialog('orderDetails');
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              xl={3}
              sx={{ marginTop: 1 }}
            >
              <BakeasyNotesLabelText
                label={t('STORE_NOTES')}
                value={latestStoreNote}
                maxLength={800}
              />
              <BakeasyLinkButton
                style={{ fontSize: '0.9rem' }}
                label={t('VIEW_ALL')}
                onClick={() => {
                  openStoreNotesDialog('orderDetails', fetchOrderHistoryById);
                }}
              />
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid container>
            <BakeasyHeaderLabel message="SHIPPING_DETAILS" />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.ShipTo
                disabled={true}
                value={selectedShipTo}
                onChange={(event: any) => {
                  setSelectedShipTo(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                disabled={true}
                value={shipToName}
                onChange={(event: any) => {
                  setShipToName(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                disabled={true}
                label={t('COMPANY_NAME')}
                value={shipToCompanyName}
                onChange={(event: any) => {
                  setShipToCompanyName(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              {/* <TextField.Country
                disabled={true}
                value={shipToCountry}
                onChange={(event: any) => {
                  setShipToCountry(event.target.value);
                }}
              /> */}
              <BakeasyTextField
                disabled={true}
                label={t('COUNTRY')}
                type="text"
                name=""
                value={
                  shipToCountry
                    ? t(`${shipToCountry?.toUpperCase().replace(/\s+/g, '_')}`)
                    : shipToCountry
                }
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                required={true}
                label={t('STATE')}
                disabled={true}
                type="text"
                name=""
                value={
                  shipToState
                    ? t(`${shipToState?.toUpperCase().replace(/\s+/g, '_')}`)
                    : shipToState
                }
                maxLength={10}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.City
                disabled={true}
                value={shipToCity}
                onChange={(event: any) => {
                  setShipToCity(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Address
                disabled={true}
                label={t('COMPANY_ADDRESS')}
                value={shipToAddress}
                onChange={(event: any) => {
                  setShipToAddress(event.target.value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Pincode
                disabled={true}
                value={shipToPostCode}
                onChange={(event: any) => {
                  setShipToPostCode(event.target.value);
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pl={2} mt={0}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.YesNo
                disabled={true}
                label={t('SHIPPING_CHARGE')}
                value={selectedShippingCharge}
                onChange={function (event: any): void {
                  setSelectedShippingCharge(event?.target?.value);
                  setSelectedShippingCalculation('');
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.ShippingCalculation
                // disabled={selectedShippingCharge === "No" ? true : false}
                disabled={true}
                // value={selectedShippingCalculation}
                value={
                  selectedShippingCalculation
                    ? t(
                        `${selectedShippingCalculation?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedShippingCalculation
                }
                onChange={(event: any) => {
                  setSelectedShippingCalculation(event?.target?.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Number
                label={t('SHIPPING_CHARGES')}
                maxLength={4}
                // disabled={selectedShippingCharge === "No" ? true : false}
                disabled={true}
                value={shippingCharges}
                onChange={(event: any) => {
                  setShippingCharges(event.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <TextField.Name
                label={t('SHIPPING_METHOD')}
                required={false}
                // disabled={selectedPreferredShippingMethod === 'Other' ? false : true}
                disabled={true}
                value={preferredShippingMethod}
                onChange={(event: any) => {
                  setPreferredShippingMethod(event.target.value);
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} pl={2} mt={0}>
            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <Dropdown.PreferredShippingMethod
                disabled={true}
                value={selectedPreferredShippingMethod}
                onChange={function(event: any): void {
                  setSelectedPreferredShippingMethod(event?.target?.value);
                  setPreferredShippingMethod(event?.target?.value);
                }}
              />
            </Grid> */}
          </Grid>

          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('TAXES')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    {/* <Dropdown.TaxRateOne
                      disabled={true}
                      value={selectedTaxRate1}
                      onChange={(event: any) => {
                        setSelectedTaxRate1(event.target.value);
                      }}
                    /> */}
                    <BakeasyAutoCompleteTax
                      label="STORE_TAX1"
                      disabled={true}
                      value={selectedTaxRate1}
                      options={
                        _taxesState.value?.data?.length > 0
                          ? _taxesState.value?.data
                          : null
                      }
                      onChange={function (newValue: any): void {
                        // throw new Error('Function not implemented.');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    {/* <Dropdown.TaxRateTwo
                      disabled={true}
                      value={selectedTaxRate2}
                      onChange={(event: any) => {
                        setSelectedTaxRate2(event.target.value);
                      }}
                    /> */}
                    <BakeasyAutoCompleteTax
                      label="STORE_TAX2"
                      disabled={true}
                      value={selectedTaxRate2}
                      options={
                        _taxesState.value?.data?.length > 0
                          ? _taxesState.value?.data
                          : null
                      }
                      onChange={function (newValue: any): void {
                        // throw new Error('Function not implemented.');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField.Name
                      disabled={true}
                      label={t('STORE_TAX1_RATE')}
                      value={
                        selectedTaxRate1?.taxName
                          ? selectedTaxRate1?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <TextField.Name
                      disabled={true}
                      label={t('STORE_TAX2_RATE')}
                      value={
                        selectedTaxRate2?.taxName
                          ? selectedTaxRate2?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('PAYMENT')} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Dropdown.PaymentMethod
                      disabled={true}
                      value={selectedPaymentMethod}
                      onChange={(event: any) => {
                        setSelectedPaymentMethod(event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Dropdown.PaymentTerms
                      disabled={true}
                      value={selectedPaymentTerm}
                      onChange={(event: any) => {
                        setSelectedPaymentTerm(event.target.value);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {ordersList?.length > 0 && (
            <>
              <BakeasyDivider />
              <Grid item xs={12} sx={{ p: 1 }}>
                <BakeasySimpleTable
                  headers={tableHeaders}
                  tableData={ordersList}
                  type={'orderDetails'}
                  data={total}
                  status={status}
                />
              </Grid>
            </>
          )}

          {status === 'Split' &&
            splitOrders?.length > 0 &&
            splitOrders?.map((order: any) => {
              return (
                <>
                  <BakeasyDivider />
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
                    <Grid
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <BakeasyHeaderLabel message={`${order?.orderId}`} />
                      <BakeasyChip label={order?.status} />
                    </Grid>
                  </Grid>
                  <Grid>
                    {order?.products?.length > 0 ? (
                      <Grid item xs={12} sx={{ p: 1 }}>
                        <BakeasySimpleTable
                          headers={tableHeaders}
                          tableData={order?.products}
                          type={'orderDetails'}
                          status={order?.status}
                          data={{
                            ...order?.amount,
                            // calculatedshippingCharge:
                            //   selectedValue !== null &&
                            //   'shippingRateType' in selectedValue
                            //     ? selectedValue['shippingRateType'] === 'Amount'
                            //       ? t('TO_BE_CONFIRMED')
                            //       : order?.amount?.calculatedshippingCharge
                            //     : '',
                          }}
                        />
                      </Grid>
                    ) : (
                      <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
                    )}
                  </Grid>
                </>
              );
            })}

          <BakeasyDivider />

          {/* <Grid>
            <Grid
              container
              spacing={1}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2
              }}
            >
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyHeaderLabel message={'PROCESS_ORDER_ID'} />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9} xl={9} container justifyContent="flex-end">
                <div className="tableOptions">
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}
                  >
                    Status:
                    <BakeasyChipInprogress label={'InProgress'} type={'status'} />
                  </Grid>
                </div>
              </Grid>
            </Grid>

            <Grid item xs={12} sx={{ mb: 5, p: 2 }}>
              {ordersList.length > 0 ? (
                <BakeasySimpleTable headers={tableHeaders} tableData={ordersList} />
              ) : (
                <BakeasyEmptyMsg message={'No Data Found'} />
              )}
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid>
            <Grid
              container
              spacing={2}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2
              }}
            >
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyHeaderLabel message={'BACK_ORDER_ID'} />
              </Grid>
              <Grid item xs={12} sm={12} md={9} lg={9} xl={9} container justifyContent="flex-end">
                <div className="tableOptions">
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}
                  >
                    Status:
                    <BakeasyChipBackOrder label={'BackOrder'} type={''} />
                  </Grid>
                </div>
              </Grid>
            </Grid>

            <Grid item xs={12} sx={{ mb: 5, p: 2 }}>
              {ordersList.length > 0 ? (
                <BakeasySimpleTable headers={tableHeaders} tableData={ordersList} />
              ) : (
                <BakeasyEmptyMsg message={'No Data Found'} />
              )}
            </Grid>
          </Grid> */}
        </Paper>
      </Grid>
    );
  }

  return orderHistoryDetailsUI();
};
